module.exports = __webpack_public_path__ + "img/fietsmderin.220eb2d1.jpg";